var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-description',{attrs:{"name":_vm.combination.itemName,"price":_vm.combination.price * _vm.quantity,"paid":_vm.paid}})
}
var staticRenderFns = []

export { render, staticRenderFns }